export default __webpack_public_path__ + "static/media/logo-efacil.103f6017.svg";